import { CardItem, DataSplit, PageGridContainer, PageGridItem, SensitivityMatrix, TenantBreakdownTable } from 'ComponentLibrary'
import { useValuationIncomePage } from './ValuationIncomePage.data'
import IncomeApproachMetricGrid from './IncomeApproachMetricGrid'
import RentMetricGrid from './RentMetricGrid'
import IncomeRatesKeyValueCardItems from 'ClientPortal/src/pages/Assets/AssetDetails/Valuation/ValuationIncomePage/IncomeRatesKeyValueCardItems'
import ValuationIncomePageLoading from './ValuationIncomePage.load'
import { getTenantBreakdown, getUsageTypeSplit } from 'ClientPortal/src/pages/Assets/AssetDetails/AssetDetails.utils'
import { useTranslation } from 'react-i18next'
import { getTenantBreakdownTableCopy } from '../tenantBreakdownTableCopy'
import { useCurrentResolvedLocale } from 'ClientPortal/src/i18n/currentLocale'
import { getSensitivityMatrixCopy } from './sensitivityMatrixCopy'

export default function ValuationIncomePage() {
    const { t: tCommon } = useTranslation('terminology', { keyPrefix: 'common' })
    const { t: tTenantUsageTypes } = useTranslation('terminology', { keyPrefix: 'common.tenantUsageTypes' })
    const { t: tTenantBreakdownTable } = useTranslation('terminology', { keyPrefix: 'common.tenantBreakdownTable' })
    const { t: tValuationIncomePage } = useTranslation('pages', {
        keyPrefix: 'assets.assetDetails.valuation.valuationIncomePage',
    })
    const locale = useCurrentResolvedLocale()
    const { valuation, isValuationPending } = useValuationIncomePage()

    if (isValuationPending) {
        return <ValuationIncomePageLoading />
    }

    if (!valuation) {
        return null
    }

    const sensitivityMatrix = valuation.income_approach_sensitivity_matrix
    const usageTypeSplit = getUsageTypeSplit(valuation.tenant_summary, tTenantUsageTypes)
    const tenantBreakdown = getTenantBreakdown(valuation.tenant_summary)
    const tenantBreakdownTableCopy = getTenantBreakdownTableCopy(tCommon, tTenantBreakdownTable)
    const sensitivityMatrixCopy = getSensitivityMatrixCopy(tCommon, tValuationIncomePage)

    return (
        <PageGridContainer>
            <PageGridItem columnSpan={3} columnSpanXs={2}>
                <CardItem height="242px">
                    <DataSplit
                        title={tCommon('marketRent')}
                        data={usageTypeSplit}
                        valueLabel={tCommon('rent')}
                        percentageLabel={tCommon('share')}
                        size="medium"
                        emptyStateTitle={tCommon('notEnoughDataAvailableYet')}
                        remainingLegendLabel={tCommon('remaining')}
                        locale={locale}
                    />
                </CardItem>
            </PageGridItem>
            <PageGridItem columnSpan={3} columnSpanXs={2}>
                <CardItem>
                    <IncomeApproachMetricGrid valuation={valuation} />
                </CardItem>
            </PageGridItem>
            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <CardItem>
                    <RentMetricGrid valuation={valuation} />
                </CardItem>
            </PageGridItem>
            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <CardItem>
                    <TenantBreakdownTable
                        data={tenantBreakdown}
                        title={tCommon('marketRent')}
                        copy={tenantBreakdownTableCopy}
                        locale={locale}
                    />
                </CardItem>
            </PageGridItem>
            <PageGridItem columnSpan={6} columnSpanXs={4}>
                <IncomeRatesKeyValueCardItems valuation={valuation} />
            </PageGridItem>
            {sensitivityMatrix && (
                <PageGridItem columnSpan={6} columnSpanXs={4}>
                    <CardItem>
                        <SensitivityMatrix
                            sensitivityMatrix={sensitivityMatrix}
                            showInfoButton
                            copy={sensitivityMatrixCopy}
                            locale={locale}
                        />
                    </CardItem>
                </PageGridItem>
            )}
        </PageGridContainer>
    )
}
